export const accountMovement = {
  accountMovementTransaction: "Transacción",
  accountMovementAmount: "Monto",
  accountMovementDeposit: "Depósitos",
  accountMovementTransfer: "Envios",
  accountMovementBet: "Apuestas",
  accountMovementWithdrawal: "Retiros",
  accountMovementBonus: "Bonos",
  movementsBtnBack: "Volver",
  accountMovementBetAll: "Todas",
  accountMovementBetWon: "Ganadas",
  accountMovementBetLost: "Perdidas",
  paginationItemsPerPage: "/ página",
  paginationJumpTo: "Ir a",
  paginationJumpToConfirm: "confirmar",
  paginationPage: "Página",
  paginationPrevPage: "Página anterior",
  paginationNextPage: "Página siguiente",
  paginationPrev5: "5 páginas anteriores",
  paginationNext5: "5 páginas siguientes",
  paginationPrevPageTooltip: "Página anterior",
  paginationNextPageTooltip: "Página siguiente",
  paginationOf: "de",
  paginationItems: "elementos",
};
